import { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";
import { Promotion } from "../../../store/features/promotionSlice";

const style = {
  fontSize: 14,
  color: theme.colors.black,
  fontWeight: 550,
};

interface Props {
  data: Promotion[];
  onBlock?: (item: any) => void;
}

function PromotionTable({ data, onBlock }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)" }}
    >
      {data.length ? (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ bgcolor: "#fff" }}>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("libelle"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("date_debut"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("date_fin"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("regle_definir"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("reduction"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("cible"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("code_promo"))}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            ).map((item: Promotion, index: any) => (
              <StyledTableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  cursor: "pointer",
                }}
              >
                <StyledTableCell>{item.libelle}</StyledTableCell>
                <StyledTableCell>{item.dateDebut}</StyledTableCell>
                <StyledTableCell>{item.dateFin}</StyledTableCell>
                <StyledTableCell>{i18n.t(item.regle || "")}</StyledTableCell>
                <StyledTableCell>{item.valeur}</StyledTableCell>
                <StyledTableCell>{i18n.t(item.cible)}</StyledTableCell>
                <StyledTableCell>{item.code}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          <CustomTableFooter
            rowsPerPage={rowsPerPage}
            data={data}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Table>
      ) : (
        <Box p={15}>
          <Typography textAlign={"center"}>{i18n.t("no_data")}</Typography>
        </Box>
      )}
    </TableContainer>
  );
}

export default PromotionTable;
